import api from "../../Hooks/axiosApi";

export const getDashboardCounts = () => {
    const response = api.get(`/api/Crm/GetDashboardCounts`);
    return response;
};

export const getLeadStageCounts = () => {
    const response = api.get(`/api/CrmLeads/GetCrmLeadsByParams`);
    return response;
};


export const getStaffStageCounts = async () => {
    //   return await axios.get("/api/ClientDasboard/staff-stage-counts");
    const response = api.get(`/api/ClientDasboard/staff-stage-counts`);
    return response;
};


// Services/CRMAdminServices/CRMDashboardService.ts

export const getNearSaleDeals = (params: any) => {
    const response = api.get('/api/CrmLeads/GetCrmLeadsByParams', { params });
    return response;
};


export const getCrmDDLService = () => {
    const response = api.get('/api/CrmLeads/GetAllLeadDDL');
    return response;
};
// export const getNearSaleDeals = (filters: {
//     stage?: string;
//     staff?: string;
//     pageNumber?: number;
//     pageSize?: number;
// }) => {
//     return api.get('/api/CrmLeads/GetCrmLeadsByParams', {
//         params: {
//             stage: filters.stage || '',
//             staff: filters.staff || '',
//             pageNumber: filters.pageNumber ?? 1,
//             pageSize: filters.pageSize ?? 10
//         }
//     });
// };

export const getStageConversionReport = () => {
    const response = api.get('/api/ClientDasboard/GetStageConversionReport');
    return response;
};

export const getFunnelData = (fromDate: string, toDate: string) => {
    const response = api.get('/api/ClientDasboard/funnel', {
        params: { fromDate, toDate }
    });
    return response;
};
// Stage funnel by the CRM stage list (Common / MB / IP / Other). Dates are AEST calendar dates, inclusive.
export const getStageFunnel = (fromDate: string, toDate: string) => {
    const response = api.get('/api/ClientDasboard/stagefunnel', {
        params: { fromDate, toDate }
    });
    return response;
};

// Which lead source is actually producing: new leads this period against the one before,
// and how far each source's leads got. Dates are AEST calendar dates, inclusive.
export const getSourceReport = (fromDate: string, toDate: string) => {
    const response = api.get('/api/ClientDasboard/source-report', {
        params: { fromDate, toDate }
    });
    return response;
};

// The owner's five numbers. No date range on purpose: these count every lead ever,
// because the question is whether the business works, not what happened last month.
export const getOwnerDashboard = (commissionPerSale = 30000, adSpendPerDay = 100, stuckDays = 14) => {
    const response = api.get('/api/ClientDasboard/owner-dashboard', {
        params: { commissionPerSale, adSpendPerDay, stuckDays }
    });
    return response;
};

/* The board: every stage Enquiry through Review, with the leads sitting on each. */
export const getPipeline = (perColumn = 200) => {
    return api.get('/api/ClientDasboard/pipeline', { params: { perColumn } });
};

/* A card dropped on another column. The stage history trigger records the move. */
export const movePipelineLead = (leadId: number, stage: string) => {
    return api.put('/api/ClientDasboard/pipeline/move', { leadId, stage });
};

/* Every conversion rate the cashflow workbook runs on, measured. */
export const getConversion = () => {
    return api.get('/api/ClientDasboard/conversion');
};

/* The two businesses side by side: units, conversion, roadblocks, wins.
   Dates are calendar dates, inclusive. stuckDays is what turns a unit into a roadblock. */
export const getBusinessDashboard = (fromDate: string, toDate: string, stuckDays = 14) => {
    return api.get('/api/ClientDasboard/business-dashboard', {
        params: { fromDate, toDate, stuckDays }
    });
};
